import { useState, useEffect, useRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom'
import {
  ArrowLeftOutlined,
  RightOutlined,
  CaretDownFilled,
} from '@ant-design/icons'
import {
  Card,
  Col,
  Divider,
  Dropdown,
  Menu,
  Row,
  Space,  
  message,
  Typography,
} from 'antd'
import { exportOption, handleExportType } from './utils'
import {
  getDpLandingInfo,  
} from 'src/DigitalProtocolModule/utils/ajax-proxy'
import { getEmail } from 'src/utils/auth'
import { TRIAL_ALIAS_STYLE } from 'src/constants/index'
import { useSelector } from 'react-redux';
import { fetchHistory } from 'src/actions/historyTrial';
import { useMarkAsCompleteHooks } from 'src/DigitalProtocolModule/hooks';
import { OVERALL_STATUS } from './constants';
import './index.scss'

const { Text } = Typography

const DprotocolLanding = () => {
  const history = useHistory();

  const { COMPLETE, NOT_START, IN_PROGRESS } = OVERALL_STATUS;

  const finalizeStatus = useSelector(fetchHistory).data?.dpFinalizeStatus;
  
  const trialUuid = localStorage.getItem('trial-id');  
  const trialDetail= JSON.parse(localStorage.getItem('trial-detail'));
  const user_name = getEmail();
  const { getSectionLockStatus } = useMarkAsCompleteHooks();

  const menusRef = useRef<any[]>([
    {
      name: "Study Population",
      mappingProp: "study_population_finalize_flag",
      progressProp: "study_population_progress_flag",
      onClick: () => navPage('/dprotocol/study-population'),
    },
    {
      name: "Arms & Cohorts",
      mappingProp: "arm_cohort_finalize_flag",
      progressProp: "arm_cohort_progress_status",
      onClick: () => navPage('/dprotocol/arms-cohorts'),
    },
    {
      name: "Schedule of Activities",
      mappingProp: "soa_finalize_flag",
      progressProp: "soa_progress_status",
      onClick: () => navPage('/dprotocol/soa'),
    },
    {
      name: "Endpoints",
      mappingProp: "endpoint_finalize_flag",
      progressProp: "endpoint_progress_status",
      onClick: () => navPage('/dprotocol/endpoints'),
    },
  ]);

  const [record, setRecord] = useState<Digital_Protocol_Landing.protocolDetails>();

  const overallStatus = useMemo(() => {
    if (!record || !finalizeStatus) return null; 
    const {
      study_population_finalize_flag,
      arm_cohort_finalize_flag,
      soa_finalize_flag,
      endpoint_finalize_flag
    } = finalizeStatus;

    // Check if all progress flags are NOT_START
    if(record['study_population_progress_flag'] === NOT_START && record['arm_cohort_progress_status'] === NOT_START && record['soa_progress_status'] === NOT_START && record['endpoint_progress_status'] === NOT_START) {
      return NOT_START;
    }
    else if(study_population_finalize_flag && arm_cohort_finalize_flag && soa_finalize_flag && endpoint_finalize_flag) {
      return COMPLETE;
    }else{
      return IN_PROGRESS;
    }
  }, [finalizeStatus, record]);

  // get title, and states
  const fetchLandingInfo = async () => {
    let origTitle = '';
    try {
      const res = await getDpLandingInfo(trialUuid, user_name);      
      if (res) {
        origTitle = res.protocol_alias || trialDetail?.trial_title;
        setRecord(res);
      }
    } catch (error) {
      origTitle = trialDetail?.trial_title;
      message.error('Failed to fetch the status');
    } 
  };

  const navPage = (url: string) => {
    history.push(url);
  }

  const backToTrial = () => {
    history.replace('/trials');
  }

  useEffect(() => {
    fetchLandingInfo();
    // get lock status for all sections
    getSectionLockStatus();
  }, [])

  return (
    <div className="main">
      <div className="header">
        <div className="header-back" onClick={backToTrial}>
          <ArrowLeftOutlined className="arrow-icon" />
          <div className="back-btn">Back to trial workspace</div>
        </div>
        <div className="header-title">         
              <Text
                underline={true}
                className="page-title"
                style={{maxWidth: TRIAL_ALIAS_STYLE.width, fontSize: TRIAL_ALIAS_STYLE.fontSize, color: TRIAL_ALIAS_STYLE.color}}
                ellipsis={
                  trialDetail?.trial_alias.length> 70
                    ? { tooltip: trialDetail?.trial_alias }
                    : {}
                }                
              >
                {trialDetail?.trial_alias}    
              </Text>
          <div className="update-time"> Last updated {record?.['last_updated']}</div>
        </div>
        
        <div className="info">
          <div className="info-row">
            <div className="trial-item">
              <label>Trial title <span className="required">*</span> </label>
              
                <span className="readonly-value trial-title-text">
                  <Text
                    style={{width: 260, fontSize:15, color:'#333'}}
                    ellipsis={{tooltip:record?.["trial_title"]}}
                  >
                    {record?.["trial_title"] || "-"}
                  </Text>
                </span>
            
            <br/>
            
            </div>
            <div className="trial-item">
              <label>Study phase</label>
              
                <span className="readonly-value">
                {!record?.["study_phase"] && "-"}
                {
                    typeof record?.["study_phase"] =='string' && record?.["study_phase"]
                  }
                  {
                    typeof record?.["study_phase"] == 'object' ? (
                      <>
                        {record?.["study_phase"] && record?.["study_phase"].length > 0 && record?.["study_phase"].join(", ") }
                      </>
                    ):''
                  }
              </span>
            
            </div>
            <div className="trial-item">
              <label>Study type</label>
              
                  <span className="readonly-value">
                  {!record?.["study_type"] && "-"}
                  {
                      typeof record?.["study_type"] =='string' && record?.["study_type"]
                    }
                    {
                      typeof record?.["study_type"] == 'object' ? (
                        <>
                          {record?.["study_type"] && record?.["study_type"].length > 0 && record?.["study_type"].join(", ") }
                        </>
                      ):''
                    }
                </span>
              
            </div>
            <div className="trial-item"></div>
          </div>
          <div className="info-row">
            <div className="trial-item">
            <label>Pediatric study</label>  
            <span className="readonly-value">
              {record?.["pediatric_study"] === null?"All":record?.["pediatric_study"].toString()=="false"?"No":(record?.["pediatric_study"].toString()=="true"?"Yes": "All")}
            </span>
            <br/>
            </div>
            <div className="trial-item">
          <label>Indication <span className="required">*</span></label>
          <span className="readonly-value">
                    {
                      typeof record?.["indication"] =='string' && record?.["indication"]
                    }
                    {
                      typeof record?.["indication"] == 'object' ? (
                        <>
                          {record?.["indication"] && record?.["indication"].length > 0 && record?.["indication"].join(", ") }
                        </>
                      ):''
                    }
                </span>
            <br/>
            </div>
            <div className="trial-item">
            <label>Therapeutic area <span className="required">*</span> </label>
            <span className="readonly-value">
                    {
                      typeof record?.["therapeutic_area"] =='string' && record?.["therapeutic_area"]
                    }
                    {
                      typeof record?.["therapeutic_area"] == 'object' ? (
                        <>
                          {record?.["therapeutic_area"] && record?.["therapeutic_area"].length > 0 && record?.["therapeutic_area"].join(", ") }
                        </>
                      ):''
                    }
                </span>
            <br/>
            </div>
            <div className="trial-item">
            <label>Estimated enrollment <span className="required">*</span></label>  
            <span className="view-endpoint">
                <b>{record?.["estimated_enrollment_count"]}</b>
              </span>
            <br />          
            </div>
          </div>
        </div>
      </div>

      <Row className="card-div" gutter={20}>
        {/* <Col span={6}>
          <Card
            title={<span className="card-title">Protocol Versions</span>}
            className="protocol"
          >
            <Row>
              {protocolVersionData.map((data, index) => (
                <Col
                  key={index}
                  span={24}
                  className={
                    protocolVersion.clicked && protocolVersion.index === index
                      ? "protocol-version-card-bg"
                      : "protocol-version-card"
                  }
                  onClick={() => handleProtocolVersionClick(index)}
                >
                  <div>
                    <div className="protocol-version-title">{data.title}</div>
                    <div className="protocol-version-desc">
                      {data.description}
                    </div>
                  </div>
                  <RightOutlined style={{ alignContent: "center" }} />
                </Col>
              ))}
            </Row>

            <Divider className="divider" />
            <div className="create-text">Create</div>
          </Card>
        </Col> */}
        <Col span={24}>
          <div className="card">
            <div className="card-title-div">
              <div className="card-title">
                Protocol Sections
                <span className="status">
                  <i className={`${overallStatus === NOT_START ? "not-started-icon" : overallStatus === COMPLETE ? 'complete-icon' : "in-progress-icon"} my_icon`}></i>{overallStatus || ""}                  
                </span>
              </div>
              
              <Dropdown
                overlay={
                    <Menu onClick={(evt) => handleExportType(evt, user_name, trialUuid)}>
                    {exportOption.map((item) => (
                      <Menu.Item key={item.key}>{item.label}</Menu.Item>
                    ))}
                    </Menu>
                }
                trigger={['click']}
                overlayStyle={{ borderColor: 'black' }}
                className="import-dropdown"
                disabled= {true}
              >
                <Space className="status-dropdown-text">
                  Export as
                  <CaretDownFilled className="dropdown-icon" />
                </Space>
              </Dropdown>
            </div>

            <Divider className="divider" />

            <Row gutter={[20, 20]} className="card-container">
              {/* {menusRef.current.map(menuItem => (
                <Col span={12} key={menuItem.name}>
                  <Card
                    className="card-items active"
                    onClick={menuItem.onClick}
                  >
                    <div className="card-item-title">
                      <div>
                        {menuItem.name}
                        <span className="status">
                          <i className={`${!finalizeStatus[menuItem.mappingProp] ? "in-progress-icon":'complete-icon'} my_icon`}></i>{finalizeStatus[menuItem.mappingProp] ? COMPLETE : IN_PROGRESS}
                        </span>
                      </div>
                      <RightOutlined className="card-item-icon" />
                    </div>
                  </Card>
                </Col>
              ))} */}
               {menusRef.current.map(menuItem => {
                const progressStatus = record?.[menuItem.progressProp];
                const sectionStatus = finalizeStatus[menuItem.mappingProp] ? COMPLETE : progressStatus === IN_PROGRESS ? IN_PROGRESS : NOT_START;
                return (
                  <Col span={12} key={menuItem.name}>
                    <Card
                      className="card-items active"
                      onClick={menuItem.onClick}
                    >
                      <div className="card-item-title">
                        <div>
                          {menuItem.name}
                          <span className="status">
                            <i className={`${sectionStatus === NOT_START ? "not-started-icon" : sectionStatus === COMPLETE ? 'complete-icon' : "in-progress-icon"} my_icon`}></i>{sectionStatus}                            
                          </span>
                        </div>
                        <RightOutlined className="card-item-icon" />
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default DprotocolLanding;
